import { Button } from "@/components/ui/button";
import { useMpStatus } from "@/hooks/usePayments";
import { Check, Loader2, X } from "lucide-react";

export function MercadoPagoStatusWidget() {
  const { data, isLoading, isFetching, isError, refetch } = useMpStatus();

  const connected = !!data?.connected;
  const title = isLoading
    ? "Checando Mercado Pago…"
    : connected
      ? "Mercado Pago conectado"
      : data?.reason === "not_configured"
        ? "Mercado Pago não configurado"
        : isError
          ? "Não foi possível checar o Mercado Pago"
          : "Token do Mercado Pago inválido";
  const subtitle = connected
    ? `Links de cartão e PIX gerados direto das parcelas${data?.nickname ? ` · ${data.nickname}` : ""}`
    : data?.reason === "not_configured"
      ? "Defina o secret MP_ACCESS_TOKEN nas Edge Functions para gerar links de pagamento."
      : "Verifique o secret MP_ACCESS_TOKEN e tente reconectar.";

  return (
    <section className="flex flex-wrap items-center gap-4 rounded-2xl border border-border bg-card px-6 py-[22px] shadow-card">
      <div
        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-[11px] ${
          isLoading
            ? "bg-muted text-muted-foreground"
            : connected
              ? "bg-ok-soft text-ok"
              : "bg-bad-soft text-bad"
        }`}
      >
        {isLoading ? (
          <Loader2 className="h-[19px] w-[19px] animate-spin" />
        ) : connected ? (
          <Check className="h-[19px] w-[19px]" strokeWidth={2} />
        ) : (
          <X className="h-[19px] w-[19px]" strokeWidth={2} />
        )}
      </div>
      <div className="min-w-[180px] flex-1">
        <div className="text-[13.5px] font-bold">{title}</div>
        <div className="text-[11.5px] text-muted-foreground">{subtitle}</div>
      </div>
      <Button
        variant="outline"
        className="h-9 rounded-[9px] px-3.5 text-[12.5px] font-semibold"
        onClick={() => refetch()}
        disabled={isFetching}
      >
        {isFetching && <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" />}
        Reconectar
      </Button>
    </section>
  );
}
